import { Checkbox, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { useMemo } from 'react';


import styles from './searchResultsSelectAll.module.scss';

type SearchResultsSelectAllProps = {
  totalCount: number;
  isAllSelected: boolean;
  isSomeSelected: boolean;
  onChange: VoidFunction;
} & PropsWithClassName;

export const SearchResultsSelectAll = ({
  className,
  totalCount,
  isAllSelected,
  isSomeSelected,
  onChange,
}: SearchResultsSelectAllProps): JSX.Element => {
  const text = useMemo(() => {
    const partial = `${totalCount} ${totalCount === 1 ? 'result' : 'results'}`;
    return partial.concat(totalCount >= 50 ? ' in the page' : '');
  }, [totalCount]);

  return (
    <label className={classNames(className, styles.root)}>
      <Checkbox
        checked={isAllSelected}
        indeterminate={isSomeSelected}
        onChange={onChange}
      />

      <Text.Paragraph variant="3" subdued>
        {text}
      </Text.Paragraph>
    </label>
  );
};
